import { formatDate } from '@ui/src';
import { RateItem } from '../types';

const formatHistoryRateList = (list: RateItem[]): RateItem[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };
    const render: Record<string, any> = {
      date: <div>{result.date && formatDate(result.date, true)}</div>,
      values: result?.logs?.edges?.map((log) => log.node),
    };

    result.render = render;

    const nextResult = {
      ...result,
      values:
        result?.logs?.edges?.map((log) => {
          const logItem = { ...log.node };

          return {
            ...logItem,
            render: {
              updatedAt: (
                <div>
                  {logItem.updatedAt && formatDate(logItem.updatedAt, true)}
                </div>
              ),
              entityTitle: (
                <div>{logItem.employeeId ? logItem.entityTitle : 'Auto'}</div>
              ),
            },
          };
        }) || [],
    };

    return nextResult;
  });

  return nextList;
};

export default formatHistoryRateList;
